import { useTheme } from '@mui/material/styles'

const useArtistApplyPageStyles = () => {
  const theme = useTheme()

  return {
    container: {
      paddingTop: '24px',
      paddingBottom: '40px',

      [theme.breakpoints.up('md')]: {
        paddingTop: '96px',
        paddingBottom: '120px',
      },
    },
  }
}

export default useArtistApplyPageStyles
